import React from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Autocomplete from 'react-autocomplete';
import axiosCancel from 'axios-cancel';
import xhr from '../../../core/Http';
import  SimpleReactValidator from 'simple-react-validator';
 
const Url='/student-fees';
const backUrl='/student'+Url;
 
class AddEditAction extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            student_name:'',
            course_year_id:'',
            student_id:'',
            status:'',
            paymentMode:'', 
            ddAmount:'',
            feeDate:moment(), 
            scholarshipID:'',
            amountPaid:'',
            studentList:[], 
            course:'',
            id_no:'',
            course_id:'',
            courseYearData:[],
            course_sem_id:'',
            quota_status:'',
            bank_name:'',
            dd_no:'',
            dd_date:'',
            neft_amount:'',
            neft_date:'',
            dd_rtgs:0,
            semesterData:[],
            feesFullData:[],
            feesData:[],
            bill_amount:0,
            dd_amount:0,
            cash:0,
            fg_amount:0,
            other_sp_amount:0,
            scholarshipData:[],
            excess_amount:0,
            balance_amount:0,
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.eventHandle=this.eventHandle.bind(this);
        this.onsubmit=this.onsubmit.bind(this);
        this.handleChangeDob=this.handleChangeDob.bind(this);
        this.handleChangeJoinDate=this.handleChangeJoinDate.bind(this);
        this.handleChangeStartDate=this.handleChangeStartDate.bind(this);
        this.handleChangeEndDate=this.handleChangeEndDate.bind(this);
        this.handleChangeDD_Date=this.handleChangeDD_Date.bind(this);
        this.onChangetext=this.onChangetext.bind(this);
        this.getYears=this.getYears.bind(this);
        this.getSemesters=this.getSemesters.bind(this);
        this.getFeesetail=this.getFeesetail.bind(this);
        this.eventHandleCalculation=this.eventHandleCalculation.bind(this);
        this.handleChangeneft_Date=this.handleChangeneft_Date.bind(this);
        this.validator = new SimpleReactValidator();
    }

    componentDidMount(){
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;
                    this.getYears(data.course_id);
                    this.getSemesters(data.course_year_id,data.course_id,data.course_sem_id);
                    //this.getFeesetail(data.course_sem_id);
                    this.setState({
                        //balance_amount:data.balance_amount,
                        student_name:data.student_name,
                        course:data.course.course_name,
                        //bank_name:data.bank_name,
                        bill_amount:data.balance_amount,
                        // cash:data.cash,
                        course_id:data.course_id,
                        //quota_status:data.quota_status,
                        course_year_id:data.course_year_id,
                        course_sem_id:data.course_sem_id,
                        //created_at:data.created_at,
                        //dd_amount:data.dd_amount,
                        //dd_date:data.dd_date!='0000-00-00 00:00:00'?moment(new Date(data.dd_date)):'',
                        //dd_no:data.student.dd_no,
                        //dd_rtgs:data.dd_rtgs,
                        //excess_amount:data.excess_amount,
                        //feeDate:moment(new Date(data.feeDate)),
                        //neft_amount:data.neft_amount,
                        //neft_date:moment(new Date(data.neft_date)),
                        //fg_amount:data.fg_scholar_amount,
                        id:data.id,
                        id_no:data.student.id_no,

                        //other_sp_amount:data.other_scholar_amount,
                        status:data.status,
                        //studentFeesDetail:data.studentFeesDetail,
                        student_fees_id:data.student_fees_id,
                        student_id:data.student_id, 
                        preloader:false, 
                    });
 
                }
            });
        } 
    } 
 

    eventHandle(e,key,val){
        this.setState({[key]:key==='check_amt'?!val?0:1:e.target.value},()=>{
 
            if(key==='dd_amount' || key==='cash' || key==='dd_rtgs' || key==='neft_amount')
                this.feesCalculation();
        });

        if(key==='course_year_id'){
            this.getSemesters(e.target.value);
        }
        if(key==='course_sem_id'){
            this.getFeesetail(e.target.value);
        }
 
    }

    onsubmit(){
        let {   
            feeDate, 
            bank_name,
            dd_no,
            dd_date,
            dd_rtgs,
            bill_amount,
            dd_amount,
            cash, 
            excess_amount,
            balance_amount, 
            neft_amount,
            neft_date,
        } =this.state;
 
        
        this.setState({preloader:true});
        if(this.validator.allValid()){
 
            let params={
                feeDate:feeDate?moment(feeDate):'',
                bank_name,
                dd_no,
                dd_date:dd_date?moment(dd_date):'',
                dd_rtgs,
                neft_amount,
                neft_date:neft_date?moment(neft_date):'',
                bill_amount,
                dd_amount,
                cash,
                excess_amount,
                balance_amount,
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData('/student-fees-due'+para,params).then((res)=>{ 
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        }else{
            this.validator.showMessages();
            this.forceUpdate();
            this.setState({ preloader:false});
        }  
    }

    handleChangeDob(date,e) {
        this.setState({
            dob: moment(date)
        });
    }
    handleChangeJoinDate(date,e) {
        this.setState({
            joining_date: moment(date)
        });
    }
    handleChangeStartDate(date,e) {
        this.setState({
            start_year: moment(date)
        });
    }
    handleChangeEndDate(date,e) {
        this.setState({
            feeDate: moment(date)
        });
    }
    handleChangeDD_Date(date,e) {
        this.setState({
            dd_date: moment(date)
        });
    }
    handleChangeneft_Date(date,e) {
        this.setState({
            neft_date: moment(date)
        });
    }

    onChangetext( e ) {
        this.setState({loading:true,loader:true,student_name:e.target.value});
        axiosCancel(xhr, { debug: false});
        const requestId = 'areasuggest';
        xhr.get('/student',{params:{search_term:e.target.value,limit:10,page:1, startDate: '', endDate:'',course_id:'', course_quota:'', course_year_id:'', other_scholarship:'', graduation:'',  }},{requestId:requestId}).then((res)=>{
            let data=res.data.data;
            if(data){
                let options=[];
                data.map((val,i)=>{
                    options.push({ value:val.name,result:val});
                });
                this.setState({loading:false,loader:false,studentList:options,selected:[]});
            }
        }); 
        xhr.cancel(requestId);
    }

    onSelectedtext(stdName,val) {
        const {course_name,id_no,course_id,course_quota,student_id} =val.result; 
        this.setState({student_name:stdName,course:course_name,id_no:id_no,course_id:course_id,quota_status:course_quota,student_id:student_id });
        this.getYears(course_id);
    }

    getYears(course_id){
        this.setState({preloader:true});
        viewData('/getallcourse-year/'+course_id).then((res)=>{ 
            this.setState({courseYearData:res.data.data,preloader:false });
        });
    }

    getSemesters(course_year_id,course_id,course_sem_id){
        this.setState({preloader:true});
        course_id=course_id?course_id:this.state.course_id;
        viewData('/getallcourse-semester/'+course_id+'/'+course_year_id).then((res)=>{ 
            this.setState({semesterData:res.data.data,preloader:false},()=>{
                if(course_sem_id)
                    this.getFeesetail(course_sem_id);
            });
        });
    }

    getFeesetail(semester_id){
        this.setState({preloader:true});
        semester_id=semester_id?semester_id:0;
        const {course_id,course_year_id}=this.state;
        viewData('/get-fees-structure/'+semester_id+'/'+course_id+'/'+course_year_id).then((res)=>{ 
            const resultData =res.data.data;
            this.setState({
                feesData:resultData.feesData,
                bill_amount:this.props.match.params.id?this.state.bill_amount:0,
                feesFullData:resultData,
                fees_structure_name:resultData.fees_structure_name,
                fees_struct_id:resultData.fees_struct_id,
                preloader:false 
            });
        });
    } 

    eventHandleCalculation(e,key,index,val){
        this.state.feesData[index][key]=!val;
        this.setState({feesData:this.state.feesData},()=>{
            let total=0;
            this.state.feesData.map((val,i)=>{
                let amount=this.state.quota_status==0?val.gq_amount:val.mq_amount;
                total=val.check_amt?parseFloat(parseFloat(total)+parseFloat(amount)):parseFloat(total);
            });
            this.setState({bill_amount:parseFloat(total)},()=>{
                this.feesCalculation();
            });
        });
    }
 
    feesCalculation=()=>{
        const {        
            bill_amount,
            dd_amount,
            cash,dd_rtgs,neft_amount } =this.state;

        const dd_amount1=!dd_amount?0:dd_amount;
        const cash1=!cash?0:cash;
        const dd_rtgs1=!dd_rtgs?0:dd_rtgs;
        const neft_amount1=!neft_amount?0:neft_amount;

        let balance_amt=0;
        if(bill_amount){
            const minus_amount=parseFloat(dd_amount1)+parseFloat(dd_rtgs1)+parseFloat(cash1)+parseFloat(neft_amount1);
            balance_amt=bill_amount-minus_amount;
        }

        if(balance_amt<0){
            this.setState({
                excess_amount:Math.abs(balance_amt),
                balance_amount:0,
            });
        }else{
            this.setState({
                excess_amount:0,
                balance_amount:balance_amt,
            });
        } 
    }
  
    
    render() { 
        let {
            student_name,
            course_year_id,
            feeDate,
            studentList,
            course,
            id_no,
            courseYearData,
            course_sem_id,
            quota_status,
            semesterData,
            feesData,
            bank_name,
            dd_no,
            dd_date,
            dd_rtgs,
            neft_amount,
            neft_date,
            bill_amount,
            dd_amount,
            cash,
            excess_amount,
            balance_amount,title,preloader} = this.state; 


        const valid_student_name=this.validator.message('student_name',student_name,'required');
        const valid_course_year_id=this.validator.message('course_year_id',course_year_id,'required');
        const valid_feeDate=this.validator.message('feeDate',feeDate,'required');
        const valid_course_sem_id=this.validator.message('course_sem_id',course_sem_id,'required');
        

        let valids=dd_amount==0 && cash==0 && dd_rtgs==0 && neft_amount==0?'required|gte:1':'';
        let cash_valid='decimal';
        let dd_valid='decimal';
        let rtgs_valid='decimal';
        let neft_valid='decimal';
        if(valids){
            cash_valid=valids;
            dd_valid=valids;
            rtgs_valid=valids;
            neft_valid=valids;
        }

        let dd_valid_required='alpha';
        let dd_valid_num='alpha_num_dash';
        let dd_valid_amt=dd_valid;
        if(dd_amount>0){
            dd_valid_required='required';
            dd_valid_num='required|alpha_num_dash';
            dd_valid_amt='required|decimal';
        }
        let neft_valid_required=neft_valid;
        if(neft_amount>0){
            neft_valid_required='required';
        }
        

        const valid_bank_name=this.validator.message('bank_name',bank_name,dd_valid_required);
        const valid_dd_date=this.validator.message('dd_date',dd_date,dd_valid_required);
        const valid_dd_no=this.validator.message('dd_no',dd_no,dd_valid_num);
        const valid_dd_amount=this.validator.message('dd_amount',dd_amount,dd_valid_amt);
        const valid_dd_rtgs=this.validator.message('dd_rtgs',dd_rtgs,rtgs_valid);
        const valid_cash=this.validator.message('cash',cash,cash_valid); 

        const valid_neft_date=this.validator.message('dd_date',neft_date,neft_valid_required);
        const valid_neft_amount=this.validator.message('cash',neft_amount,neft_valid); 
  
        let css= {
            position: 'fixed',
            overflow: 'auto',
            zIndex:1,
            maxHeight: '35%',
        };
        let total=0;

        return (

            <div id="page_content_inner">
                <h3 className="heading_b uk-margin-bottom">{title} Student Fee</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding"> 

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${student_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Name<span className="req">*</span></label>
                                    <Autocomplete  inputProps={{ className:`md-input ${valid_student_name ?'md-input-danger':''}` }} wrapperStyle={{display:'inline',zIndex:'102',height:'200'}}
                                        menuStyle={css}
                                        getItemValue={(item) => item.value}
                                        items={studentList}
                                        renderItem={(item, isHighlighted,i) =>
                                            <div key={item.result.id} style={{ background: isHighlighted ? 'lightgray' : 'white',zIndex:'102' }}>
                                                {item.value}
                                            </div>
                                        }
                                        value={student_name}
                                        onChange={(e) =>this.onChangetext(e)}
                                        //onSelect={(e) =>this.onSelectedtext.bind(e,val.list,i)}
                                        onSelect={this.onSelectedtext.bind( this )}
                                    />  
                                    {valid_student_name}
                                </div>
                            </div>
                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${id_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="R.No">R.No<span className="req">*</span></label>
                                    <input type="text" name="id_no" value={id_no} onChange={this.setStateFromInput} className={ 'md-input'} />  
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${feeDate ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Fee Date">Fee Date<span className="req">*</span></label>
                                    <DatePicker showYearDropdown showMonthDropdown 
                                        scrollableYearDropdown minDate={moment().add(0, 'days')} yearDropdownItemNumber={20} selected={feeDate} dateFormat="DD/MM/YYYY" className={ `datepicker md-input ${valid_feeDate ?'md-input-danger':''}`}  onChange={this.handleChangefeeDateDate} /> 
                                    {valid_feeDate} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-4"> 
                                <div className={ `md-input-wrapper ${course ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Course Name">Course Name<span className="req">*</span></label>
                                    <input type="text" name="course" value={course} onChange={this.setStateFromInput} className={ 'md-input'} />  
                                </div>
                            </div>
                        </div>  


                        

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${neft_amount ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="NEFT">NEFT Amount<span className="req">*</span></label>
                                    <input type="text" name="neft_amount" value={neft_amount}onChange={(e)=>{ 
                                        this.eventHandle(e,'neft_amount');
                                    }} className={ `md-input ${valid_neft_amount ?'md-input-danger':''}`} /> 
                                    {valid_neft_amount} 
                                </div>
                            </div> 
                             
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${neft_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Aadhar No">NEFT Date<span className="req">*</span></label>
                                    <DatePicker showYearDropdown showMonthDropdown 
                                        scrollableYearDropdown minDate={moment().add(-10, 'days')} yearDropdownItemNumber={20} selected={neft_date} dateFormat="DD/MM/YYYY" className={ `datepicker md-input ${valid_neft_date ?'md-input-danger':''}`}  onChange={this.handleChangeneft_Date} /> 
                                    {valid_neft_date} 
                                </div>
                            </div>
                            
                        </div> 
                        
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${bank_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Bank Name">Bank Name<span className="req">*</span></label>
                                    <input type="text" name="bank_name" value={bank_name}onChange={(e)=>{ 
                                        this.eventHandle(e,'bank_name');
                                    }} className={ `md-input ${valid_bank_name ?'md-input-danger':''}`} /> 
                                    {valid_bank_name} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${dd_no ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="DD No">DD No<span className="req">*</span></label>
                                    <input type="text" name="dd_no" value={dd_no}onChange={(e)=>{ 
                                        this.eventHandle(e,'dd_no');
                                    }} className={ `md-input ${valid_dd_no ?'md-input-danger':''}`} /> 
                                    {valid_dd_no} 
                                </div>
                            </div>
                             
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${dd_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Aadhar No">DD Date<span className="req">*</span></label>
                                    <DatePicker showYearDropdown showMonthDropdown 
                                        scrollableYearDropdown minDate={moment().add(-10, 'days')} yearDropdownItemNumber={20} selected={dd_date} dateFormat="DD/MM/YYYY" className={ `datepicker md-input ${valid_dd_date ?'md-input-danger':''}`}  onChange={this.handleChangeDD_Date} /> 
                                    {valid_dd_date} 
                                </div>
                            </div>
                            
                        </div> 

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${dd_amount>=0 ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="DD Amount">DD Amount<span className="req">*</span></label>
                                    <input type="text" name="dd_amount" value={dd_amount}onChange={(e)=>{ 
                                        this.eventHandle(e,'dd_amount');
                                    }} className={ `md-input ${valid_dd_amount ?'md-input-danger':''}`} /> 
                                    {valid_dd_amount} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${cash>=0 ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Cash">Cash<span className="req">*</span></label>
                                    <input type="text" name="cash" value={cash}onChange={(e)=>{ 
                                        this.eventHandle(e,'cash');
                                    }} className={ `md-input ${valid_cash ?'md-input-danger':''}`} /> 
                                    {valid_cash} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${dd_rtgs>=0 ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="RTGS">RTGS<span className="req">*</span></label>
                                    <input type="text" name="dd_rtgs" value={dd_rtgs}onChange={(e)=>{ 
                                        this.eventHandle(e,'dd_rtgs');
                                    }} className={ `md-input ${valid_dd_rtgs ?'md-input-danger':''}`} /> 
                                    {valid_dd_rtgs} 
                                </div>
                            </div>
                           
                        </div> 

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${bill_amount>=0 ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Billing Amount">Due Amount<span className="req">*</span></label>
                                    <input type="text" name="bill_amount" value={bill_amount} className='md-input' />  
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${excess_amount>=0 ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Excess Amount">Excess Amount<span className="req">*</span></label>
                                    <input type="text" name="excess_amount" value={excess_amount} className='md-input' />  
                                </div>
                            </div>
                            <div className="uk-width-medium-1-3"> 
                                <div className={ `md-input-wrapper ${balance_amount>=0 ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Balance Amount">Balance Amount<span className="req">*</span></label>
                                    <input type="text" name="balance_amount" value={balance_amount} className='md-input' />  
                                </div>
                            </div>
                        </div> 
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                
                                <button type="button" onClick={(e)=>{
                                    this.onsubmit();
                                }} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                                
                            </div>
                        </div> 
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Student/StudentFees/payDueAmount.js